'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExternalArrow = require('./ExternalArrow');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExternalArrow).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ExternalArrow/index.js
// module id = 1178
// module chunks = 1